import { pdfRender } from './pdfRender.js';
import { propPanel } from './propPanel.js';
import { uiRender } from './uiRender.js';
const textSchema = { pdf: pdfRender, ui: uiRender, propPanel };
export default textSchema;
export const readOnlyText = {
    pdf: textSchema.pdf,
    ui: textSchema.ui,
    propPanel: {
        ...textSchema.propPanel,
        defaultSchema: {
            ...textSchema.propPanel.defaultSchema,
            type: 'readOnlyText',
            readOnly: true,
            readOnlyValue: textSchema.propPanel.defaultValue,
        },
    },
};
//# sourceMappingURL=index.js.map